import { SearchClient, AzureKeyCredential } from "@azure/search-documents";

console.log(process.env.VUE_APP_NDX);
const searchClient = new SearchClient(
  process.env.VUE_APP_SEARCHURL,
  process.env.VUE_APP_NDX,
  new AzureKeyCredential(process.env.VUE_APP_SEARCHKEY)
);

export default searchClient;
